import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const BarcodeOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function BarcodeOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M5 5H2.5v14H5v2H.5V3H5v2ZM23.5 21H19v-2h2.5V5H19V3h4.5v18ZM7.507 16h-2V8h2v8ZM13.007 16h-2V8h2v8ZM18.507 16h-2V8h2v8Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default BarcodeOutlined;